@if (matchingAutoComplete().variant) {
  @for(message of messages; track $index ) {
    <div class="card mt-2">
      <p-message icon="pi pi-info-circle"  [severity]="message.severity"
                >{{message.detail}}
      </p-message>
    </div>
  }
}

@if (providerProduct) {


    <p-table
        #dt1 [value]="datasource" [(selection)]="selectedVariantItem" (selectionChange)="validation()" dataKey="code"
        [paginatorDropdownAppendTo]="'body'" [tableStyle]="{ 'min-width': '20rem' }" responsiveLayout="stack"
        stripedRows
        breakpoint="992px" [styleClass]="'p-datatable-sm border surface-border'"
        [globalFilterFields]="['productVariantItem.Code', 'productVariantItem.Name']">
        <ng-template #caption>
            <div class="flex items-center justify-between  gap-2">

              <p-inputgroup class="!w-auto" styleClass="!w-auto">
                <p-inputgroup-addon>
                  <i class="pi pi-search"></i>
                </p-inputgroup-addon>
                <input
                    #globalSearch pInputText type="text" #filter
                    (input)="dt1.filterGlobal($any($event.target).value ?? '', 'contains')" placeholder="Arama..."/>
      </p-inputgroup>
                <div>
                    <a
                            class="cursor-pointer block lg:hidden text-surface-700 dark:text-surface-100" pStyleClass="@next" enterClass="hidden"
                            leaveToClass="hidden" [hideOnOutsideClick]="true">
                        <i class="pi pi-bars text-4xl"></i>
                    </a>
                    <div
                            class="items-center flex-grow-1 justify-content-between hidden lg:flex absolute lg:static
                right-0 top-30 z-3 shadow-mdlg:shadow-none">
                        <ul
                                class="list-none p-2 gap-0 lg:gap-2 m-0 flex lg:items-center select-none flex-col lg:flex-row"
                                [ngClass]="{
                            'bg-surface-0 dark:bg-surface-800':windowWidth<992
                            }" style="min-height:80px;min-width:200px">


                            @if (providerProduct.Id.length === 0) {
                                <li>

                                    <div
                                            pTooltip="Bu pazaryeri/e-ticaret varyantı destekliyor. Her varyantı ayrı ürün olarak açmak istiyorsanız 'Basit Ürün'  aktif edin"
                                            class="flex lg:flex-wrap gap-1 mr-2  items-center px-4 lg:px-1">


                                        <p-checkbox
                                                [(ngModel)]="eachVariantAProduct" binary="true"/>
                                        <p class="m-0 text-center lg:text-left w-full lg:w-auto  text-primary lg:text-color">
                                            Basit Ürün</p>


                                    </div>
                                </li>
                            }

                            <li>
                                @if (globalSearch.value.length > 0) {
                                    <button
                                            pButton label="Filtreyi Kaldır" icon="pi pi-filter-slash" [ngClass]="{
                            'p-button-text w-full':windowWidth<992,
                            'p-button-outlined ml-1 w-auto ':windowWidth>992
                            }" (click)="clear(dt1); filter.value =''"></button>
                                }
                            </li>
                            <li>
                                <div class="ml-auto flex flex-col lg:block ">
                                    <button
                                            pButton label="Toplu Eşleştir " icon="pi pi-refresh" [ngClass]="{
                            'p-button-text w-full':windowWidth<992,
                            'p-button-outlined mr-2 w-auto ':windowWidth>992
                            }" (click)="openVariantMatching()"></button>
                                    <button
                                            pButton label="Özellik Eşleştir" (click)="featureMatch()" [ngClass]="{
                            'p-button-text w-full':windowWidth<992,
                            'p-button-outlined w-auto mr-2':windowWidth>992
                            }" icon="pi pi-sort-alt"></button>
                                    <button
                                            [ngClass]="{
                            'p-button-text w-full':windowWidth<992,
                            'p-button-outlined w-auto mr-2':windowWidth>992
                            }" pButton label="Eşleşmeleri Temizle" icon="pi pi-trash" (click)="clearMatch()"></button>
                                  <button
                                            [ngClass]="{
                            'p-button-text w-full':windowWidth<992,
                            'p-button-outlined w-auto mr-2':windowWidth>992
                            }" pButton label="Varyantları Yenile" icon="pi pi-sync" (click)="refreshVariants(true)"></button>
                                </div>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>

            <div class="flex justify-between mt-2 items-center lg:hidden">

                <div class=" flex items-center gap-2 ">
                    <p class="my-1">Tümünü Seç</p>
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </div>
                <div class="flex items-center gap-2">
                    <p class="my-1">Durumu</p>
                    <p-columnFilter type="boolean" field="matching"></p-columnFilter>
                </div>
            </div>
        </ng-template>
        <ng-template #header>
            <tr>
                <th style="width: 4rem">
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th style="width: 5%;">
                    Kodu
                </th>
                @if (providerProduct.MarketplaceIdentity === IdentityEnum.N11) {
                    <th style="width: 10%;">
                        Adı
                    </th>
                } @else {
                    <th style="width: 20%;">
                        Adı
                    </th>
                }

                @if (providerProduct.MarketplaceIdentity === IdentityEnum.N11) {
                    <th style="width: 10%;">

                        Katalog Id

                    </th>
                }
                <th style="width:65%">
                    Varyant Eşleştirme
                </th>
                <th style="width:10%">
                    <div class="lg:flex items-center gap-2 hidden">
                        <p class="m-0">Durumu</p>
                        <p-columnFilter type="boolean" field="matching"></p-columnFilter>
                    </div>
                </th>

            </tr>
        </ng-template>
        <ng-template #body let-rowData>
            <tr>
                <td>
                    <p-tableCheckbox [value]="rowData"></p-tableCheckbox>

                </td>
                <td>
                    <span class="p-column-title font-bold">Kodu</span>
                    {{ rowData.productVariantItem.Code }}
                </td>
                <td>
                    <span class="p-column-title font-bold">Adı</span>
                    {{ rowData.productVariantItem.Name }}
                </td>
                @if (providerProduct.MarketplaceIdentity === IdentityEnum.N11) {

                    <td>
                        <span class="p-column-title font-bold">Katalog Id</span>
                        <input
                                type="text" pInputText (ngModelChange)="changeCatalogId(rowData, $event)"
                                [(ngModel)]="rowData.catalogId"/>
                    </td>
                }

                <td>

                    <p-table
                            class="w-full" responsiveLayout="stack" breakpoint="992px" id="inTable"
                            [value]="rowData.providerProductVariantList" [tableStyle]="{ 'min-width': '20rem' }"
                            styleClass="border-t border-surface"  stripedRows>
                        <ng-template #body let-variantItem>
                            <tr class="border-t border-surface lg:border-t-0">
                                <td style="width:10%">
                                    <span class="p-column-title font-bold">Varyant Adı</span>
                                    {{ variantItem.VariantKey }}
                                </td>
                                <td style="width:40%">
                                    <span class="p-column-title font-bold">Değer Seçimi</span>
                                  @if(providerSettings?.Variant?.sendOurVariant){
                                    {{ variantItem.lowercaseName }}
                                  }
                                    @else{

                                    <p-select
                                      class="w-full"
                                            emptyFilterMessage="Varyant Adı Bulunamadı"
                                            [options]="providerCategoryAttributes()" [filter]="true" filterBy="Name"
                                            appendTo="body" [(ngModel)]="variantItem.lowercaseName"
                                            (ngModelChange)="changeName($event,variantItem,rowData)"
                                            [virtualScroll]="true" [virtualScrollItemSize]="20" optionLabel="Name"
                                            optionValue="lowercaseName" placeholder="Seçimi Yapınız"></p-select>
                                    }
                                </td>
                                <td style="width:10%">
                                    <span class="p-column-title font-bold">Varyant Değeri</span>
                                    {{ variantItem.VariantValue }}
                                </td>
                                <td style="width:40%">
                                  @if(providerSettings?.Variant?.sendOurVariant){
                                    {{variantItem.lowercaseValue}}
                                  }
                                  @else {
                                    @if (variantItem.NameMatchin) {
                                      @if (variantItem.Values.length > 0) {
                                            <p-select
                                              class="w-full"
                                              [options]="variantItem.Values" [filter]="true"
                                              filterBy="Value" appendTo="body"
                                              [(ngModel)]="variantItem.lowercaseValue"
                                              emptyFilterMessage="Varyant Değeri Bulunamadı"
                                              (ngModelChange)="changeValue($event,variantItem,rowData)"
                                              [virtualScroll]="true" [virtualScrollItemSize]="20"
                                              optionLabel="Value" optionValue="lowercaseValue"
                                              placeholder="{{variantItem.Name}} Seçimi Yapınız"></p-select>

                                      } @else {

                                            <input
                                              class="w-full"
                                              type="text" [(ngModel)]="variantItem.Value"
                                              (ngModelChange)="changeValue($event,variantItem,rowData)"
                                              placeholder="{{variantItem.Name}} Alanını Doldurun"
                                              pInputText />


                                      }
                                    } @else {
                                      <p-chip
                                        class="w-full lg:w-auto"
                                        styleClass="w-full lg:w-auto justify-center"
                                        [label]="variantItem.VariantKey + ' Alanının Karşılığını Seçiniz'"></p-chip>
                                    }
                                  }
                                </td>
                            </tr>
                            <tr>
                        </ng-template>
                    </p-table>
                </td>
                <td>
                    <span class="p-column-title font-bold">Durumu</span>
                    @if (rowData.matching) {
                        <p-chip styleClass="pl-0 pr-4">
                        <span class="bg-green-200 text-white rounded-full w-8 h-8 flex items-center justify-center"><i
                                class="pi pi-check"></i></span>
                            <span class="ml-2 font-medium">Eşleşti</span>
                        </p-chip>
                    } @else {
                        <p-chip styleClass="pl-0 pr-4">
                        <span class="bg-red-200 text-white rounded-full w-8 h-8 flex items-center justify-center"><i
                                class="pi pi-times"></i></span>
                            <span class="ml-2 font-medium">Eşleşmedi</span>
                        </p-chip>
                    }
                </td>
            </tr>
        </ng-template>
    </p-table>
}



